/* eslint-disable unicorn/prefer-spread */
import {
  configureStore,
  type ThunkAction,
  type UnknownAction,
} from "@reduxjs/toolkit";

import listenerMiddleware from "./listenerMiddleware";
import { sentryBreadcrumbMiddleware } from "./sentryBreadcrumbMiddleware";
import { sentryReduxEnhancer } from "./sentryEnhancer";
import { rootReducer, type RootState } from "./slices";

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(listenerMiddleware)
      .concat(sentryBreadcrumbMiddleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type Store = typeof store;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  undefined,
  UnknownAction
>;
